import { Box } from "@chakra-ui/react"
import { FC, useRef } from "react"
import { Dropdown } from "../common"
import { Input, InputWrapper } from "../settings/settings.styled"
import { SettingMicrophone } from "../settings/settingsMicrophone"

export const DevTest: FC = () => {
  const inputWrapper = useRef<HTMLDivElement>(null)
  return (
    <>
      <h1>test</h1>
      <Box overflow={"visible"} height={"100px"} margin={"100px"}>
        <InputWrapper isSmallWindowHeight={false} ref={inputWrapper}>
          <Dropdown
            label={"test"}
            onChange={() => {}}
            // list={devicesLists.audio}
            list={[
              { id: "0", label: "test" },
              { id: "1", label: "test" },
              { id: "2", label: "test" },
              { id: "3", label: "test" },
              { id: "4", label: "test" }
            ]}
            emptyText={"nothing"}
          />
          {/* <Input /> */}
        </InputWrapper>
      </Box>
    </>
  )
}
